import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

/**************************
 *        STYLES
 *************************/

import 'leaflet/dist/leaflet.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './assets/sass/_bootstrap.scss'
import './assets/sass/style.scss'


/**************************
 *        MODULES
 *************************/
import * as utils from './modules/utils'






/**************************
 *        COMPONENTS
 *************************/
import AppHeader from './components/includes/AppHeader'
import Loader from './components/helper/Loader'
import Pagination from 'vue-pagination-2';
import Multiselect from 'vue-multiselect'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'



Vue.component('Loader', Loader)
Vue.component('AppHeader', AppHeader)
Vue.component('pagination', Pagination);
Vue.component('multiselect', Multiselect)
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)





/**************************
 *        PLUGINS
 *************************/

 import modal from './plugins/modal'
 import moment from './plugins/moment'
 import { vueMessage } from './plugins/message'
 import { validationConfig, VeeValidate } from './modules/validate'
 import excel from 'vue-excel-export'
 import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
 import Vuelidate from 'vuelidate'
 import feather from 'vue-icon'
 import { Plugin } from 'vue-fragment'
 import { LMap, LTileLayer, LMarker,LTooltip } from 'vue2-leaflet';

 Vue.prototype.$moment              = moment
 Vue.use(modal)
 Vue.use(vueMessage)
 Vue.use(VeeValidate, validationConfig)
 Vue.use(excel)
 Vue.use(utils.clone(VuePersianDatetimePicker), {
     name: 'date-picker',
     props: {
         format: 'YYYY-MM-DD',
         displayFormat: 'jDD jMMMM jYYYY',
         color: '#ff5981',
         autoSubmit: true
     }
 })
 Vue.use(utils.clone(VuePersianDatetimePicker), {
     name: 'time-picker',
     props: {
         type: 'time',
         format: 'HH:mm:00',
         altFormat: 'HH:mm:00',
         displayFormat: 'HH:mm',
         color: '#ff5981'
     }
 })
 Vue.use(Vuelidate);
 Vue.use(feather, 'v-icon')
 Vue.use(Plugin)
 Vue.component('l-map', LMap);
 Vue.component('l-tile-layer', LTileLayer);
 Vue.component('l-marker', LMarker);
 Vue.component('l-tooltip', LTooltip);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
